import { FC, useEffect, useMemo, useRef, useState } from 'react';

import BybitTable from '@/components/SearchTablePage/BybitTable';
import { refreshSearchTable } from '@/components/SearchTablePage/utils';
import { BybitSearchListRef } from '@/components/SearchTablePage/utils/commonInterface';
import { useUserProfile } from '@/hooks/useUserProfile';
import { UserInfo } from '@/services/types/common';

import { calPermission, IPermissionRecord, usePermission } from './helper';

interface IPermissionProps {
  value?: React.Key[];
  defaultValue?: React.Key[];
  readOnly: boolean;
  onChange?: (permission: any) => void;
  disabled: boolean;
}
export const Permission: FC<IPermissionProps> = (props) => {
  const { readOnly, onChange, disabled } = props;
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>(
    props.defaultValue || props.value || [],
  );

  useEffect(() => {
    refreshTable();
  }, [readOnly]);

  const { userInfo } = useUserProfile();
  const searchListRef = useRef<BybitSearchListRef<IPermissionRecord>>();
  const { getPermissionColumns, getPermissionDataSource } = usePermission();
  const refreshTable = () => {
    refreshSearchTable({}, searchListRef);
  };

  // 判断用户是否完成kyc，包括企业kyc（member_tag?.KYC）和个人kyc（kyc_person_level 是 1和2）
  const hasKyc = () => {
    return (
      String((userInfo as UserInfo)?.member_tag?.KYC) === '1' ||
      Number((userInfo as UserInfo)?.kyc_person_level) > 0
    );
  };

  const dataSource = useMemo(() => {
    const hasKYC = hasKyc();
    return getPermissionDataSource(hasKYC);
  }, [userInfo, getPermissionDataSource]);

  useEffect(() => {
    const permissions = calPermission(selectedRowKeys);
    onChange && onChange(selectedRowKeys?.length ? permissions : undefined);
  }, [props?.defaultValue]);

  return (
    <div className="bybit-api-edit-list">
      <BybitTable<IPermissionRecord>
        {...{
          searchListRef,
          columns: getPermissionColumns(
            dataSource as IPermissionRecord[],
            readOnly,
          ),
          rowKey: 'id',
          footer: () => null,
          dataSource,
          tableProps: {
            className: 'bybit-table-list',
            rowSelection: {
              selectedRowKeys,
              getCheckboxProps: (row) => ({
                disabled: row.disabled || disabled,
                // name: record.type,
              }),
              onChange: (selectedRowKeys) => {
                setSelectedRowKeys(selectedRowKeys);
                const permissions = calPermission(selectedRowKeys);
                onChange &&
                  onChange(selectedRowKeys?.length ? permissions : undefined);
              },
            },
          },
        }}
      />
    </div>
  );
};
